window.CancelarOrcamentoController = ControllerBase.extend({
    name: "CancelarOrcamentoController",
    framework: "knockout",
    idPedidoCancelado: 0,
    numeroVia: 0,
    bindingRegion: "#form-cancelar-orcamento-container",

    antesBinding: function () {
        setTimeout(function () {
            $("#modalImprimirComprovante").hide();
        }, 300);
        idPedidoCancelado = 0;
        numeroVia = 0;
        $("html, body").scrollTop(0);

        // Início - Controle de Exclusividade.
        // 491123 — namespaced (.controleExclusividade): sem namespace, o $(window).unbind("beforeunload")
        // de pesquisarOrcamentoController.excluirControleExclusividade() apaga TODO handler de
        // beforeunload em window, inclusive o de orcamentoController (aviso de orçamento em andamento).
        $(window).on("beforeunload.controleExclusividade", $.proxy(this.confirmExit, this));
        $(window).on("unload.controleExclusividade", $.proxy(this.leavePage, this));
        // Fim - Controle de Exclusividade.
    },
    aposBinding: function () {
        if (this.model.OrcamentoUnificado()) {
            $("#selecionar-todos-produtos").hide()
            $("#CancelaroOrcamento_ObservacaoGeral").attr('disabled', true)
        }

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    // Início - Controle de Exclusividade.
    confirmExit: function () {
        return "Você tem certeza de que quer sair?";
    },

    leavePage: function () {
        global.ajax({
            url: "/Comum/ExcluirControleDeExclusividade",
            type: "post",
            async: false,
            data: {
                actionParameter: this.numeroPedido,
                nomeTabela: "PEDICLICAD"
            }
        });
    },
    // Fim - Controle de Exclusividade.

    ajax: function () {

        return {
            url: "/Orcamento/_CancelarOrcamento",
            type: "post",
            data: {
                numeroPedido: this.numeroPedido,
                tipoOrcamento: this.tipoOrcamento
            }
        };
    },

    events: {
        'click #selecionar-todos-produtos': "selecionarTodos"
    },

    atacharEventos: function () {
        $("#breadcrumb-cancelar").unbind();
        $("#breadcrumb-cancelar").click($.proxy(this.pesquisarAoVoltar, this));
        $("input").on('focus', function () { $(this).select(); });
    },

    pesquisarAoVoltar: function () {
        this.cancelarOrcamentoCallback();
    },

    selecionarTodos: function () {
        if (this.model.OrcamentoUnificado())  //  427169
            return //  427169
        if (!this.model.selecionarTodos) {
            this.appendToModel({ name: "selecionarTodos", value: true });
        } else {
            this.model.selecionarTodos(!this.model.selecionarTodos());
        }

        var selecionarTodos = this.model.selecionarTodos();

        $.each(this.model.Itens(),
            function () {
                //var status = this.DescricaoSituacaoDeFaturamento();
                //if (status != "Cancelado" && status != "Faturado") { // FNX-964
                //    this.Selecionado(selecionarTodos);
                //}
                //                var podeCancelar = (this.MensagemErro()=="");
                if (this.MensagemErro() == "") { // FNX-964
                    this.Selecionado(selecionarTodos);
                }
            });
    },

    selecionarItem: function (model) {
        if (this.model.OrcamentoUnificado())  //  427169
            return //  427169
        var dados = this.toJS(model);

        if (dados.Selecionado == false) {

            var self = model;

            //global.ajax({
            //    url: "/Orcamento/_ValidarItemSelecionado",
            //    type: "post",
            //    data: {
            //        numeroItem: dados.Codigo
            //    },
            //    success: function (data) {

            //        if (data && data.HasErrors) {
            //            return;
            //        }
            //        if (model.MensagemErro() == "") model.Selecionado(true);
            //    }
            //});
            if (model.MensagemErro && model.MensagemErro() != null && model.MensagemErro() != "") {
                global.showWarnMessage(model.MensagemErro());
            } else {
                model.Selecionado(true);
            }

        } else {
            model.Selecionado(false);
        }
    },

    validarImprimirComprovante: function () {
        return idPedidoCancelado > 0;
    },

    obterCodigoPedidoCancelado: function () {
        return idPedidoCancelado;
    },

    obterNumeroVia: function () {
        numeroVia = numeroVia + 1;
        return numeroVia;
    },

    cancelar: function () {
        var cancelamento = this.toJS(this.model);

        cancelamento.Itens = global.where(cancelamento.Itens, { Selecionado: true });

        if (cancelamento.Itens.length == 0) {
            global.showErrorMessage("Não foi marcado nenhum produto!");
            return;
        }

        var self = this;

        //REMOVER ESTE CÓDIGO APÓS SOLUCIONAR ITENS SELECIONADOS
        var teste = this.toJS(this.model);
        $.each(cancelamento.Itens, function (indexPai, valuePai) {

            $.each(teste.Itens, function (indexFilho, valueFilho) {

                if (valueFilho.CodigoTinta == valuePai.CodigoTinta && valueFilho.Codigo != valuePai.Codigo && valueFilho.TipoComponente == "C") {
                    cancelamento.Itens.push(valueFilho);
                }
            });
        });

        global.ajax({
            url: "/Orcamento/CancelarOrcamento",
            type: "post",
            data: {
                numeroPedido: this.numeroPedido,
                itensACancelar: cancelamento,
                codigoCliente: this.codigoCliente
            },
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }

                if (data && data.Mensagem && typeof data.Mensagem == "string" && data.Mensagem != "") {
                    global.showSuccessMessage(data.Mensagem);
                }

                if (data.ImprimeComprovanteCredito && data.IdPedidoCancelado > 0) {
                    idPedidoCancelado = data.IdPedidoCancelado;
                    self.atacharEventos();
                    $("#div-data-breadcrumb").hide();
                    $("#form-cancelar-orcamento-container").hide();
                    $("#modalImprimirComprovante").show();
                } else
                    self.cancelarOrcamentoCallback();
            }
        });
    },

    formConfig: {
        selector: "#form-cancelar-orcamento",
        submit: {
            selector: "#cancelar-orcamento",
            loadingText: "Aguarde...",
            callback: "cancelar",
            type: "model",
            modelType: "js"
        },
        rules: {
            'Motivo': {
                required: true
            }
        },
        messages: {
            'Motivo': {
                required: "O campo \"Motivo\" é obrigatório."
            }
        },

        ignore: []

    },

    pesquisarCliente: function () {
        self = this;

        this.pesquisarClientesController = this.showView({
            region: {
                name: "pesquisarClientesRegion",
                selector: "#pesquisar-clientes-pesquisa-cancelamento-region"
            },
            controller: {
                type: PesquisarClientesController,
                args: {
                    clienteSelecionadoCallbackView: $.proxy(self.clienteSelecionado, self)
                }
            }
        });
    },

    removerCliente: function () {
        this.model.CodigoCliente(undefined);
        this.model.NomeCliente(undefined);
        this.codigoCliente = 0;
    },

    clienteSelecionado: function (cliente) {
        if (!cliente) {
            return;
        }
        this.model.CodigoCliente(cliente.get("Codigo"));
        this.model.NomeCliente(cliente.get("Nome"));
        this.pesquisarClientesController.hide();

        this.codigoCliente = cliente.get("Codigo");

        $("html, body").scrollTop(0);
        this.show();
    }
});